import turboMount, { registerComponent } from '@/global/turbo-mount';
import { SubscriptionForm } from '@/components/react/paid-registration';

registerComponent(turboMount, 'SubscriptionForm', SubscriptionForm);
